function getStatus(statusObject) {
    return statusObject.buyable
        ? 'inStock'
        : statusObject.stockNotificationEnabled
            ? 'notifyWhenBack'
            : 'outOfStock';
}
function StockStatusContainer({ product, children }) {
    const { status, text, maxOrderQuantity, stockDate } = useStockStatus(product);
    if (!status)
        return null;
    // Mimic fn-as-child pattern
    return children({
        status,
        text,
        maxOrderQuantity,
        stockDate
    });
}
function useStockStatus(product) {
    const stockStatus = product === null || product === void 0 ? void 0 : product.stockStatus;
    if (!stockStatus) {
        console.warn('The provided product does not have a stockStatus');
        return {
            status: null,
            text: null,
            maxOrderQuantity: null,
            stockDate: null
        };
    }
    return {
        status: getStatus(stockStatus),
        text: stockStatus.text || null,
        maxOrderQuantity: stockStatus.maxOrderQuantity,
        stockDate: stockStatus.stockDate
    };
}
export default StockStatusContainer;
export { useStockStatus };
//# sourceMappingURL=StockStatusContainer.js.map